<template>
  <section class="page page--user-registration" data-js="page">
    <div class="page__left">
      <div class="page__content page__content--left">
        <PageHeader :actions="!hasDesktopResolution" />

        <div class="page__body">
          <PageTitles>
            <template v-slot:title>
              A plataforma que pode mudar a mobilidade corporativa da sua
              empresa.
            </template>

            <template v-slot:desc>
              Este canal é destinado ao cadastro de novas empresas, caso seja um
              colaborador e gostaria de utilizar nossos serviços entre em
              contato com seu gestor.
            </template>
          </PageTitles>
          <SyncEmail
            v-if="showSyncEmail"
            :phone-country-code="phoneCountryCode"
            :phone-number="phoneNumber"
          />
          <Form :synced-phone-number="phoneNumber" />
        </div>
      </div>
    </div>

    <div v-if="hasDesktopResolution" class="page__right">
      <Tips />
    </div>
    <PebbleModal
      :icon="require('@/assets/svg/icons/error.png')"
      :visible="showWrongCountryModal"
      title="Atenção"
      content="Esta plataforma aceita apenas números de telefone brasileiros. Cadastre-se usando outro número."
      confirmText="Confirmar"
      @confirm="handleModalConfirm"
    />
  </section>
</template>

<script>
import mediaQueries from 'mixins/mediaQueries'
import PageHeader from 'components/pageHeader'
import PageTitles from 'components/PageTitles'
import Form from 'components/userRegistration/Form'
import Tips from 'components/userRegistration/tips'
import SyncEmail from 'components/userRegistration/SyncEmail'
import email from '@/services/email'
import PebbleModal from '@/components/PebbleModal.vue'
import getPassportUrl from '@/libs/passport'

const isV4 = false
export default {
  name: 'UserRegistration',
  mixins: [mediaQueries],
  metaInfo () {
    return {
      titleTemplate: this.routeTitle + ' | %s'
    }
  },
  components: {
    PageHeader,
    PageTitles,
    Form,
    Tips,
    SyncEmail,
    PebbleModal
  },
  computed: {
    routeTitle () {
      return this.$route.meta.title
    },

    hasDesktopResolution () {
      return this.isDesktop || this.isLargeDesktop || this.isExtraLargeDesktop
    },

    routeQueries () {
      return this.$route.query
    },

    showSyncEmail () {
      return isV4 || localStorage.getItem('testFlag') === 'true'
    }
  },
  data () {
    return {
      phoneCountryCode: '',
      phoneNumber: '',
      showWrongCountryModal: false
    }
  },
  methods: {
    async getUserInfo () {
      try {
        const response = await email.getInfo()
        const { data } = response || {}
        const { phone_info: phoneInfo } = data || {}
        const {
          phone_country_code: phoneCountryCode,
          phone_number: phoneNumber
        } = phoneInfo || {}
        this.phoneCountryCode = phoneCountryCode
        this.phoneNumber = phoneNumber
        if (phoneCountryCode !== 'BR') {
          this.showWrongCountryModal = true
          return
        }
      } catch (error) {
        console.error('Failed to get user info:', error)
      }
    },
    handleModalConfirm () {
      this.showWrongCountryModal = false
      window.location.href = getPassportUrl().logout
    },
    sendGTMDataLayer () {
      this.$GTMDataLayer.send({
        event: 'cadastro-step1',
        'step-form': '1-dados-do-cadastro'
      })
    }
  },
  mounted () {
    // this.$apiService.greyTest() // 注册白名单测试，用于测试接口灰度是否生效
    this.sendGTMDataLayer()
    this.getUserInfo()
  }
}
</script>

<style lang="scss" scoped>
.page__content--left {
  @media (min-width: 1200px) {
    padding-right: 98px;
  }
}

.page__left {
  background-color: $white;
}

.page__right {
  background-color: $gray-1;
  border-left: 1px solid $gray-3;
  flex-direction: column;
}
</style>
